import React from 'react';
import MyText from './MyText';
import { MdOutlineAttachFile } from "react-icons/md";


export default function FileUploader(props) {
    const fileInputRef = React.useRef(null);
    const [files, setFiles] = React.useState([]);

    const handleUpload = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        const selectedFiles = Array.from(event.target.files);
        if (props.multi) {
            setFiles((prev) => {
                const updatedFiles = [...prev, ...selectedFiles];
                props.onChange && props.onChange(updatedFiles);
                return updatedFiles;
            });
        } else {
            setFiles(selectedFiles);
            props.onChange && props.onChange(selectedFiles);
        }
    };

    return (
        <div style={{ ...styles.container, ...props.containerStyle }}>
            <MyText style={{ ...styles.label, ...props.labelStyle }}>{props.label}</MyText>
            <input
                ref={fileInputRef}
                type="file"
                accept=".doc,.docx,.pdf"
                onChange={handleFileChange}
                multiple={props.multiple}
                hidden
            />
            <div style={styles.inputContainer} onClick={handleUpload}>
                {files.length > 0 ?
                    files.map((file) => {
                        return <div key={file.name} style={styles.fileContainer}>
                            <MdOutlineAttachFile style={styles.icon} />
                            <MyText >{file.name}</MyText>
                        </div>
                    }) :
                    <div style={styles.fileContainer}>
                        <MdOutlineAttachFile style={styles.icon} />
                        <MyText style={styles.placeholder}>{props.placeholder}</MyText>
                    </div>}
            </div>
        </div>
    );
};
const styles = {
    container:{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
    },
    label:{
        fontSize: '1.2rem',
    },
    inputContainer:{
        // height: 30,
        minWidth: 50,
        borderRadius: 10,
        border: 'none',
        padding: '0.5rem 1rem',
        boxShadow: '0px 4px 4px 0px #0000000D',
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 10,
        cursor: 'pointer',
    },
    fileContainer: {
        height: 24,
        display: "flex",
        flexDirection: "row",
        justifyContent: "start",
        alignItems: "center",
        width: "100%",
        gap: 8
    },
    icon:{
        fontSize: 20,
        color: '#C6C6C6',
    },
    placeholder:{
        color: '#C6C6C6',
    }
}